export interface IAddressSuggestionRequest extends Components.Schemas.IAddressSuggestionRequest { }
export interface IAddressSuggestionResponse extends Components.Schemas.IAddressSuggestionResponse { }
export interface IAddressSuggestion extends Components.Schemas.IAddressSuggestion { }
export interface IReverseGeocodingRequest extends Components.Schemas.IReverseGeocodingRequest { }

export type TVariantMode = 'create' | 'edit'

declare global {
  interface Window {
    ymaps: any;
    opera: any
    getCurrentMoySkladStatusInterval: any
  }
}

export interface IDateFilter {
  from: string
  to: string
}

export interface ISelectedCity {
  label: string
  value: string
  lat: number | null
  lng: number | null
}

export interface IAlertData<T> {
  visible: boolean
  type: T | null
}

export enum EnhanceSocketEvent {
  PROCESSING_STARTED = 'processing_started',
  PROCESSING_PROGRESS = 'processing_progress',
  PROCESSING_COMPLETED = 'processing_completed',
  PROCESSING_ERROR = 'processing_error',
  JOB_CREATED = 'job_created',
  SUBSCRIBED = 'subscribed',
  UNSUBSCRIBED = 'unsubscribed',
}

export enum EnhanceSocketIncomingEvent {
  ENHANCE_DESCRIPTION = 'enhance_description',
  ENHANCE_CHARACTERISTICS = 'enhance_characteristics',
  ENHANCE_IMAGE = 'enhance_image',
  BULK_ENHANCE = 'bulk_enhance',
  SUBSCRIBE_TO_JOB = 'subscribe_to_job',
  UNSUBSCRIBE_FROM_JOB = 'unsubscribe_from_job',
  REMOVE_BACKGROUND = 'remove_background',
}